// extracted by mini-css-extract-plugin
export default {"share_wrapper":"shareBox-module__share_wrapper--OPeOL","link_wrapper":"shareBox-module__link_wrapper--dS8js","icon_wrapper":"shareBox-module__icon_wrapper--kC0X3"};